import { useWorkspace } from "../context/WorkspaceContext";
import HomePage from "src/features/Stage/HomePage";
import StagePage from "src/stage/StagePage";
import { Skeleton } from "src/stage/StageUi";
import WorkspaceOnboarding from "./WorkspaceOnboarding";

// AUTO-CRM-32: /workspace is the CRM Home (src/features/Stage/HomePage.jsx).
export default function WorkspaceEntryPage() {
  const { loading, workspaces } = useWorkspace();

  if (loading) {
    return (
      <StagePage>
        <div aria-label="Loading your workspace" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Skeleton width={220} height={12} />
          <Skeleton width={360} height={34} radius={12} />
          <Skeleton height={96} radius={20} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16 }}>
            <Skeleton height={280} radius={20} /><Skeleton height={280} radius={20} /><Skeleton height={280} radius={20} />
          </div>
        </div>
      </StagePage>
    );
  }

  if (workspaces.length === 0) return <WorkspaceOnboarding />;

  return <HomePage />;
}
